import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import "./BlogDetails.css";
import { ApiBaseUrl, SiteUrl } from "../../utils/constants";

const BlogDetails = () => {
  const { name: slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [blog, setBlog] = useState(location.state || null);
  const [loading, setLoading] = useState(!location.state);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (location.state) {
      setBlog(location.state);
      setLoading(false);
      return;
    }

    fetch(`${ApiBaseUrl}blogs`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch blogs");
        return res.json();
      })
      .then((data) => {
        const found = (data.data || []).find((item) => item.url === slug);
        if (found) {
          setBlog({
            ...found,
            date: found.createdAt
              ? new Date(found.createdAt).toLocaleDateString()
              : "",
          });
        } else {
          setNotFound(true);
        }
        setLoading(false);
      })
      .catch(() => {
        setNotFound(true);
        setLoading(false);
      });
  }, [slug, location.state]);

  if (loading) {
    return (
      <div className="blog_details">
        <div className="coustom_container">Loading...</div>
      </div>
    );
  }

  if (notFound || !blog) return <h2>Blog not found</h2>;

  const metaTitle = blog.metaTitle || blog.title || "Blog Details";
  const metaDescription =
    blog.metaDescription || "Read more about this health topic.";
  const blogSlug = blog.url || slug;
  const canonicalUrl = `${SiteUrl}/blog/${blogSlug}`;
  const keywords = Array.isArray(blog.keywords)
    ? blog.keywords.join(", ")
    : blog.keywords || `${metaTitle}, ${metaDescription}`;

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={keywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="article" />
        {blog.image && <meta property="og:image" content={blog.image} />}
      </Helmet>
      <div className="blog_details">
        <div className="coustom_container">
          <Button className="mb-4" onClick={() => navigate(-1)}>
            ← Back
          </Button>

          <img src={blog.image} alt={blog.title} className="details_img" />

          <p className="details_date">{blog.date}</p>

          <h1>{blog.title}</h1>

          <div
            className="details_content"
            dangerouslySetInnerHTML={{ __html: blog.description }}
          />
        </div>
      </div>
    </>
  );
};

export default BlogDetails;
